<template>
    <div v-if="themeStore.themeIndex === 1">
        <GiftCodeViewOne :data-set="dataSet" @pasteCode="pasteCode" @claimSubmit="claimSubmit" @goToShare="goToShare"/>
    </div>
     <div v-if="themeStore.themeIndex === 2">
        <GiftCodeViewTwo :data-set="dataSet" @pasteCode="pasteCode" @claimSubmit="claimSubmit" @goToShare="goToShare"/>
    </div>
     <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
     <LoadingScreen ref="loadingRef" />
</template>
<script setup lang="ts">
import { onMounted, ref , computed} from 'vue';
import { Capacitor } from "@capacitor/core";
import { Clipboard } from '@capacitor/clipboard';
import { getRedeemcodeClaim } from '@/api/giftCode';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getActivityInformations } from '@/api/common';
import { Share } from '@capacitor/share';
import GiftCodeViewOne from '@/themes/themeOne/giftCode/giftCodeView.vue';
import GiftCodeViewTwo from '@/themes/themeTwo/giftCode/giftCodeView.vue';
import { GiftCodeData } from './giftCodeView';
import { useThemeStore } from '@/stores/theme';

const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const themeStore = useThemeStore()

const couponCode = ref('');
const activityInfo = ref([])
const bannerIcon = ref()

const dataSet = computed<GiftCodeData>(() => ({
    activityInfo: activityInfo.value,
    bannerIcon: bannerIcon.value,
    couponCode: couponCode.value
}))

const pasteCode = async () => {
    if (Capacitor.isNativePlatform()) {
        const { type, value } = await Clipboard.read();
        couponCode.value = value;
    } else {
        // For web platform
        navigator.clipboard.readText()
            .then((text) => {
                couponCode.value = text;
            })
            .catch((err) => {
                console.error('Failed to get clipboard data', err);
            });
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "redeem_code"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        bannerIcon.value = res.data?.floatIcon
        activityInfo.value = JSON.parse(res.data?.activityIntro)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
const claimSubmit = (e:any) => {
    loadingRef.value.open()
    let data = {
        claimCode: e
    }
    getRedeemcodeClaim(data).then(res => {
        loadingRef.value.close()
        showSuccess(res?.msg)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const goToShare = async () => {
   let shareLink =  localStorage.getItem('shareLink')
   
   try {
       if (!shareLink) { return }
        await Share.share({
            text: shareLink,
        });
    } catch (error) {
       console.warn('Not supporting') 
    }
}
onMounted(() => {
    getActivityInfo()
})
</script>
<style scoped>
.cuponContainer {
    padding: 50px 0;
}

.gift-banner {
    position: relative;
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.banner-img {
    width: 100%;
}

.middleCard {
    background-color: #3e2c23;
    border-radius: 15px;
    border-bottom: 3px solid #dd7a33;
    border-top: 3px solid #dd7a33;
    padding: 15px;
    position: absolute;
    bottom: 15px;
    width: 80%;
}

.couponInput {
    margin: 10px 0;
    color: #FFF;
    border: 1px solid #dd7a33;
    background-color: #2d201a;
    border-radius: 10px;
}

.shareIconContainer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.shareCard {
    color: #FFF;
    border: 1px solid #dd7a33;
    background: #30240f;
    background: radial-gradient(circle, rgb(45 36 21) 0%, rgb(57 38 21) 50%, rgb(100 61 17) 100%);
    border-radius: 10px;
    width: 80%;
    padding: 10px;
}

.titleImage img {
    width: 65%;
}

.titleText {
    font-weight: bold;
    font-size: 13px;
    color: #f0a853;
}

.mediaIcons {
    background: #0000005c;
    border-radius: 10px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
}

.mediaIcons img {
    width: 30px;
    padding: 5px 10px;
}

.middle-row {
    position: relative;
}

.exchange-btn {
    display: flex;
    justify-content: center;
    padding: 15px;
}

.exchange-btn img {
    width: 40%;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}




.giftCode_container {
    min-height: 100vh;
    padding: 0rem 1rem;
}

::v-deep .exchange-btn .van-button--large {
    color: #FCD7A1;
    font-weight: bold;
    background-image: linear-gradient(#F39A4F 0%, #78340F 100%);
    border: 2px solid #FCD7A1;
    text-align: center;
    font-size: .426rem;
    box-shadow: 0 8px 12px 0 rgba(120, 52, 15, 0.45);
    border-radius: 30px;
}

.middle-card {
    width: 100%;
    height: auto;
    display: block;
    position: absolute;
}

.top-text {
    color: #FFFFFFD9;
    font-size: 14px;
    pointer-events: none;
    text-align: center;
    white-space: nowrap;
}

.activity-text {
    color: #FFFFFF73;
    font-size: 14px;
    margin: 10px 0px;
    line-height: 20px;
}

.middle-container {
    max-width: 100%;
    margin: 0 auto;
    padding-top: 27vh;
    position: relative;

}


.couponInput ::v-deep .van-field {
    line-height: 1.64rem !important;
    background: transparent !important;
    font-size: 10px !important;
}

.couponInput ::v-deep .van-field__control {
    font-size: 15px;
    padding: 5px 0px;
    color: #ffffff !important;
}

::v-deep(.pasteInput .van-field__control::placeholder) {
    color: #ffffff73 !important;
    font-size: 15px;
    opacity: 1;
}

.activity-title-row {
    display: flex;
    align-items: center;
    margin: 25vh 0vh 0vh;
}

.media-img-content {
    width: 8%;
    background-color: #ffffff0a;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    left: 47%;
    top: 322%;
    border: 5px solid #ffffff0a;
}

.media-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.left-img {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-right: 0.2rem;
}

.activity-title {
    color: #FFFFFFD9;
    font-size: 15px;
    display: flex;
    justify-content: center
}

.right-img {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-left: 0.2rem;
}


.copy-btn {
    width: 100%;
}
</style>